<form class="h-100 container" [style.visibility]="ready? 'visible' : 'hidden'">
  <div>
    <app-errormsg [errorDiv]="errorDiv" [errorMsg]="errorMsg"></app-errormsg>
    <div id="multi-credentials-selection_title" class="o-form-explain">Select a way to sign in</div>
  </div>


  <!-- All radio buttons -->
  <div>
    <div class="row channelSelection" *ngFor="let cred of credentialOptions">
      <div class="container col">
        <mat-radio-button name="radiogroup" [checked]="cred.default" (change)="onSelect(cred)" >
          {{cred.credValue}}
          <ng-container *ngIf="cred.tag">
            <fa-icon [icon]="getIconForTag(cred.tag)" class="pe-2" [title]="getTitleForTag(cred.tag)"></fa-icon>
            <span class="text-muted d-none d-md-inline">({{ getTitleForTag(cred.tag) }})</span>
          </ng-container>
        </mat-radio-button>
        </div>
      </div>
    </div>

  <div id="outer">
    <div class="row mt-3">
      <div class="inner col"> <button class="primary-btn" [disabled]="!credential || clicked" (click)="onSendCode()">{{buttonLabel?buttonLabel:'Send Code'}}</button></div>
      <div class="inner col"> <button class="secondary-btn" (mousedown)="factorSelect()" *ngIf="factorSelection">More Options</button></div>
    </div>
  </div>

  <div>
    <app-userinfo></app-userinfo>
    <app-loading *ngIf="!ready && !errorDiv"></app-loading>
  </div>
</form>
